import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import './tailwind.css';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, <App />);
} else {
  createRoot(rootElement).render(<App />);
}

// Load reCAPTCHA after app has rendered
const RECAPTCHA_SITE_KEY = '6LdrkZArAAAAAFagTf1DUI77pb59JT81RJTLNHRP';

const loadRecaptcha = () => {
  const existingScript = document.querySelector(`script[src*="recaptcha/api.js"]`);
  if (existingScript) return;

  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
};

window.addEventListener('load', loadRecaptcha);
